var exports = module.exports = {};

exports.pageCollection = function (posts, pageSize) {
  return posts.reduce((collection, item, i) => {
    const current = Math.floor(i / pageSize)
    if (!collection[current]) collection.push([])
    collection[current].push(item)
    return collection
  }, []);
};

exports.replaceBlogImagePlaceholders = function (content, slug) {
  return content.replace(/(\|\|IMG-PLACEHOLDER\|)([\w.]+)/g, (match, p1, p2, p3, offset, string) => {
    return '<img class = "blog-post-img" src="/img/blog/' + slug + '/' + p2 + '">';
  });
}

exports.replacePressImagePlaceholders = function (content, slug) {
  return content.replace(/(\|\|IMG-PLACEHOLDER\|)([\w.]+)/g, (match, p1, p2, p3, offset, string) => {
    return '<img class = "press-post-img" src="/img/press/' + slug + '/' + p2 + '">';
  });
}

exports.getStaticContent = function (contentful, key) {
  return contentful.staticContent.find(function (value, index) {
    return value.key == key;
  });
}



// WEBPACK FOOTER //
// ./assets/js/utils.js